import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { useTimeEntryMode } from '../../../../useTimeEntryMode'

const StyledButton = styled(Button)`
  font-size: 0.75rem;
  left: -0.5rem;
  line-height: 1rem;
  text-transform: none;
`

const ToggleModeButton = () => {
  const { beManualMode, isManualMode } = useTimeEntryMode()
  const { t } = useTranslation()
  const toggleTimeEntryMode = () => beManualMode && beManualMode(!isManualMode)
  const displayText = isManualMode ? t('common.label.selectFromAvailabilities') : t('common.label.manuallyAddTime')

  return <StyledButton onClick={toggleTimeEntryMode}>{displayText}</StyledButton>
}

export { ToggleModeButton }
